import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import TableContext from "context/table/tableContext";

import { SingleInfoProps } from "./types";

const SingleInfo = ({ cardName, title }: SingleInfoProps) => {
    const { tableName } = useContext(TableContext);

    const { t } = useTranslation();

    return (
        <li>
            <span
                css={css({
                    fontWeight: "600"
                })}
            >
                {t([`Table##${title}`, `General##${title}`])}
            </span>

            {" - "}

            <span>
                {t(
                    `Table details##tooltip info##${tableName}##${cardName}##${title}`
                )}
            </span>
        </li>
    );
};

export default SingleInfo;
